export default class PhoneButton {
    constructor($elt) {
        this.$elt = $elt;
        this.isActive = false;
        this._init();
    }

    _init() {
        this._addEvents();
    }

    _addEvents() {
        this.$elt.addEventListener('click', this._onClick.bind(this));
    }

    _onClick(e) {
        if (e.pointerType !== 'touch') {
            if (!this.isActive) {
                e.preventDefault();
                this.$elt.classList.add('is-active');
                this.isActive = true;
            }
        }
    }
}